<template>
  <Modal
    :value="value"
    @hide="hide()"
    title="Sign up"
    :skipCloseOnBgClick="true"
  >
    <template slot="body" class="content">
      <BForm :elements="form" mode="lazy" @valid="form.valid = $event"></BForm>
    </template>
    <template slot="footer" class="content">
      <div
        :disabled="!form.valid || isLoading"
        :class="{ 'is-loading': isLoading }"
        class="button is-primary"
        @click="save()"
      >
        Sign up
      </div>
      <div class="button" @click="hide()">Cancel</div>
    </template>
  </Modal>
</template>

<script>
import { postApi } from "@/utils/http";

export default {
  props: {
    value: Boolean,
  },
  components: {
    BForm: () => import("@/components/singles/BForm/component.vue"),
    Modal: () => import("@/components/main/Modal.vue"),
  },

  data() {
    return {
      isLoading: false,
      form: {
        valid: false,
        inputs: [
          {
            focus: true,
            icon: "mdi-card-account-details-outline",
            name: "firstname",
            placeholder: "First name",
            type: "text",
            validation: "min:1|max:30",
            value: "",
          },
          {
            icon: "mdi-card-account-details-outline",
            name: "lastname",
            placeholder: "Last name",
            type: "text",
            validation: "min:1|max:30",
            value: "",
          },
          {
            icon: "mdi-email",
            name: "username",
            placeholder: "Email",
            type: "email",
            validation: "email",
            value: "",
          },
          {
            icon: "mdi-lock",
            name: "password",
            placeholder: "Password",
            type: "password",
            validation: "min:8|confirmed:confirmation",
            value: "",
          },
        ],
      },
    };
  },
  created() {},

  mounted() {},
  methods: {
    async save() {
      if (this.form.valid && !this.isLoading) {
        try {
          this.isLoading = true;

          if (this.$store.state.auth.success) {
            await postApi("signup", this.getForm(), { fullDataObject: true });
          } else {
            await postApi("signup", this.getForm(), {
              skipAuth: true,
              fullDataObject: true,
            });
          }

          this.$helpers.notify("Success", "Sign up is complete.", "success");
          this.$emit("complete", this.getForm());
          this.isLoading = false;
          this.hide();
        } catch ({ response }) {
          if (response.status == 409) {
            this.$helpers.notify("User", "The user already exists.", "info");
          } else if (response.status == 500) {
            this.$helpers.notify(
              "Error",
              "Internal server error, please try again later.",
              "danger"
            );
          } else if (response.status == 400) {
            console.log(response.data);
            this.$helpers.notify("Error", "Missing parameter.", "danger");
          } else if (response.status == 401) {
            console.log(response.data);
            this.$helpers.notify("Error", "Permission denied.", "warning");
          }
        }

        this.isLoading = false;
      }
    },
    getForm() {
      return {
        firstName: this.form.inputs[0].value,
        lastName: this.form.inputs[1].value,
        mail: this.form.inputs[2].value,
        password: this.form.inputs[3].value,
      };
    },
    hide() {
      if (!this.isLoading) this.$emit("hide", false);
    },
  },
};
</script>
